import Style from "./OrdersTableStyle";
import Spinner from "../../shared/Spinner/Spinner";
import api from "../../services/api";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";

export interface OrderData {
  id: number;
  userName: string;
  apartmentNumber: number;
  blockName: string;
  enterpriseName: string;
  newInstallment: number;
  newInterestRate: string;
  newPaymentOption: string;
  artValue: number;
  cleaningTaxValue: number;
  entryPayed: number;
  paymentDate: string;

  rawInstallments: number;
  rawSimpleRate: string;
  rawInstallmentPrice: number;
  orderValueBase: number;
  orderValue: number;
  orderDate: number;
  contractId: number;
  url: string;
}

export default function OrdersTable(props) {
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState<OrderData[]>();

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setLoading(true);
    GetOrders().then(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function GetOrders() {
    try {
      const orders = await api.get(`orders`);
      setOrders(orders.data.orders);
      setErrorMessage("");
    } catch (error) {
      console.error(error);
      setErrorMessage("Não foi possível carregar pedidos, erro " + error);
    }
  }
  function goGoToEdit(orderId: number) {
    props.history.push(`/orders/${orderId}`);
  }

  function onUploadContract(order) { }

  function GetInstallmentText(order: OrderData) {
    var installment = order.rawInstallments
      ?? order.newInstallment
      ?? 1;

    if (installment) {
      return installment === 1 ? "À vista" : `${installment}x`;
    } else {
      return "";
    }
  }

  return (
    <Style>
      <PageTitle title="Pedidos" />
      <Spinner spinning={loading} />
      <section className="table-title">
        <h1>Pedidos</h1>
      </section>
      {errorMessage && <h1 className="alert alert-error"> {errorMessage}</h1>}
      <table className="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>Pedido</th>
            <th>Nome do cliente</th>
            <th>Empreendimento</th>
            <th>Bloco</th>
            <th>Ap</th>
            {
              // <th>Valor (sem taxa)</th>
              // <th>Valor parcela</th>
            }
            <th>Parcelas</th>
            <th>Data do pedido</th>
            <th>Visualizar</th>
          </tr>
        </thead>
        <tbody>
          {orders &&
            orders.length > 0 &&
            orders.map((order) => {
              return (
                <tr key={order.id} className="clickable">
                  <td onClick={() => goGoToEdit(order.id)}>{order.id}</td>
                  <td onClick={() => goGoToEdit(order.id)}>{order.userName}</td>
                  <td onClick={() => goGoToEdit(order.id)}>
                    {order.enterpriseName}
                  </td>
                  <td onClick={() => goGoToEdit(order.id)}>
                    {order.blockName}
                  </td>
                  <td onClick={() => goGoToEdit(order.id)}>
                    {order.apartmentNumber}
                  </td>

                  {
                    // <td onClick={() => goGoToEdit(order.id)}>
                    //   {CentsToHuman(order.orderValueBase)}
                    // </td>
                    // <td onClick={() => goGoToEdit(order.id)}>
                    //   {CentsToHuman(
                    //     order.orderValue /
                    //     (order.newInstallment
                    //       ? order.newInstallment
                    //       : order.installment)
                    //   )}
                    // </td>
                  }
                  <td onClick={() => goGoToEdit(order.id)}>
                    {GetInstallmentText(order)}
                  </td>
                  <td onClick={() => goGoToEdit(order.id)}>
                    {new Date(order.orderDate).toLocaleString()}
                  </td>
                  {order.url ? (
                    <td
                      onClick={() => onUploadContract(order)}
                      className="clickable"
                    >
                      <div className="action">
                        <FaEye className="icon" />
                      </div>
                    </td>
                  ) : (
                    <td className="clickable">
                      <div className="action">
                        <FaEyeSlash className="icon" />
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
        </tbody>
      </table>
    </Style>
  );
}
